import type { InlineBookmarkPluginElement } from '../types';

import { InlineBookmarkElement } from './InlineBookmarkElement';
import type { RenderElementProps } from '../../../core';

type InlineTemplateElementProps = Readonly<{
  children: React.ReactNode;
  selected?: boolean;
  leftDelimiter: React.ReactNode;
  rightDelimiter: React.ReactNode;
  testID?: string;
  attributes: RenderElementProps['attributes'];
  element: InlineBookmarkPluginElement;
  ['data-editor-element']?: string;
  variant?: string;
}>;

export const InlineBookmarkTemplate = ({
  attributes,
  children,
  element,
  leftDelimiter,
  selected,
  rightDelimiter,
  variant,
  ...rest
}: InlineTemplateElementProps): React.ReactElement => {
  return (
    <span>
      <InlineBookmarkElement
        {...attributes}
        element={element}
        variant={variant}
        selected={selected}
      >
        {children}
      </InlineBookmarkElement>
    </span>
  );
};
